import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { useConfigUI } from '@/features/config/context'
import { FormFlowValve } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function updateFlowValve(payload: FormFlowValve): Promise<void> {
  await flowValveApi.update(payload)
}

const useEditFlowValve = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: FormFlowValve) => updateFlowValve(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.flowValve])
      toast.success(t('UpdateFlowValveSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useEditFlowValve
